import { defineAction } from '~/prix'
import { z } from 'zod'
import inseminationDeleteAction from './inseminationDelete.action.json' with { type: 'json' }
import { inseminationObject } from '../inseminationObject'

const inseminationDeleteDefinition = defineAction({
  ...inseminationDeleteAction,

  input: inseminationObject.pick({ id: true }),
  output: inseminationObject.pick({ id: true }),
})

export default inseminationDeleteDefinition
